import PropTypes from 'prop-types';

import { useIdentity } from '@zenbusiness/application-commons-identity';
import Avatar from '@zenbusiness/zui/Avatar';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

const getNameInitials = (first = '', last = '') => {
  const firstInitial = first.trim().charAt(0).toUpperCase();
  const lastInitial = last.trim().charAt(0).toUpperCase();
  return `${firstInitial}${lastInitial}`;
};

function UserChatBubble({ message }) {
  const {
    firstName, lastName
  } = useIdentity();

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Avatar>
        {getNameInitials(firstName, lastName)}
      </Avatar>
      <Text size="sm">
        {message}
      </Text>
    </Stack>
  );
}

UserChatBubble.propTypes = {
  message: PropTypes.string.isRequired
};

export default UserChatBubble;
